module.exports = __webpack_public_path__ + "img/empty.3491d7f9.png";